import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M3.08905 17.517C2.83805 17.517 2.58805 17.422 2.39505 17.234C2.00505 16.851 1.99905 16.223 2.38205 15.834L11.2701 6.78001C11.4561 6.59101 11.7101 6.48401 11.9751 6.48401H11.9761C12.2411 6.48401 12.4951 6.59001 12.6811 6.77901L21.6151 15.833C21.9991 16.222 21.9951 16.849 21.6051 17.233C21.2171 17.618 20.5891 17.614 20.2051 17.223L11.9791 8.88501L3.79505 17.221C3.60205 17.419 3.34505 17.517 3.08905 17.517V17.517Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ChevronUp');

export default Icon;
